import { EPermissionsKeys } from '../../Layout/permissionEnums'

const WRITE_CAPABLE_LEAVE_LEVELS = [1, 2, 3, 5, 6, 8]

export const isLimitedLeaveViewerOnly = (userStore) => {
  const hasLimitedLeaveAccess = userStore?.permissionsKeys?.includes(
    EPermissionsKeys.ALLOWED_TO_VIEW_LIMITED_LEAVES
  )
  const canWriteLeaves = WRITE_CAPABLE_LEAVE_LEVELS.includes(userStore?.userLevel)

  return Boolean(hasLimitedLeaveAccess && !canWriteLeaves)
}
